import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const degreeService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);

            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/degree/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching directory list:", error);
            throw error;
        }
    },

    async findById(degreeId: number): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/degree/findById/${degreeId}`);
            return response.data;
        } catch (error) {
            console.error("Error findById degree", error);
            throw error;
        }
    },

    async save(degree: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/degree/save`,
                degree
            );
            return response.data;
        } catch (error) {
            console.error("Error save degree", error);
            throw error;
        }
    },

    async deleteById(degreeId: number): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/degree/deleteById/${degreeId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById degree", error);
            throw error;
        }
    }
}

export default degreeService;